export default __webpack_public_path__ + "static/media/check.a958184d.svg";